<template>
	<div>
		<el-tabs v-model="activeName" @tab-click="handleClick">
			
			<el-tab-pane v-for="(item,key) in this.$data.tabs" v-bind:key="key" :label="item.name" :name="item.component" >
				<component :is="item.component" v-if="item.component==nowPage"></component>
			</el-tab-pane>
		     <!-- <h1>{{siteId}}---{{siteIdF}}</h1> -->
		</el-tabs>
		
	</div>
	
</template>

<script>
	import DataRl from '../../components/data/DataRl.vue'
	import DataHist from '../../components/data/DataHist.vue'
	import DayReport from '../../components/data/DayReport.vue'
	import MonthReport from '../../components/data/MonthReport.vue'
	import YearReport from '../../components/data/YearReport.vue'
	import HisMap from '../../components/data/HisMap.vue'
	import DayRecord from '../../components/data/DayRecord.vue'
	import RemoteCtr from '../../components/data/RemoteCtr.vue'
	// import {initSites} from '../../utils/sites.js'
	export default {
		name: "DataDis",
		//props:["siteId"],
	    data() {
	      return {
	        activeName: "",
			nowPage:"",
			tabs:[],
			//siteId:0//this.$store.state.siteId
	      }
		  
	    },
		
		components:{
			DataRl,
			DataHist,
			DayReport,
			MonthReport,
			YearReport,
			HisMap,
			DayRecord,
			RemoteCtr
		},
		mounted() {
			this.initTabs();
		},
		// computed:{
			
		// 	siteIdF() {
		// 		//console.log("hachlog:"+this.$store.state.siteId);
		// 		this.$data.siteId=this.$store.state.siteId;
		// 	    return this.$store.state.siteId;;
		// 	},
		// },
		// watch:{
		// 	siteId(val, newval){
		// 		
		// 	}
		// },
		// beforeCreate(){
		// 	
		// 	if(this.$store.state.sites.length==0){
		// 		initSites(this.$store);
		// 	}
		// },
	    methods: {
	      handleClick(tab, event) {
			  //debugger
			  this.nowPage = tab.name;
			  //var comp=this.$data.tabs[tab.index].component;
			  //this.$store.commit('initTabId',tab.index);
			  console.log(this.$data.activeName);
	        //console.log(tab, event);
	      },
		  initTabs(){
			  
			  //var st=this.$data.siteId;
			  
			  
			 // while(true)
			 // {
				//  if(this.$store.state.sites.length>0)
				//  break;
			 // }
			 var that=this;
			  var para="?id="+JSON.parse(window.sessionStorage.getItem("user")).id;
			  this.getRequest('/data/real/getTabs'+para).then(resp => {
				    
			  		var json=resp.data; 			  					
					if(json.length==0){
						this.$message({
						  type: 'info',//success/warning/info/error/;
						  message: "无符合条件的数据。"
						});
						
						
					}else{
						that.$data.tabs=resp.data;
						that.$data.activeName=resp.data[0].component;	
						that.$data.nowPage=resp.data[0].component;
						//debugger
						console.log(that.$data.tabs);
					}
			  	})
		  }
	    }
	  }
</script>
	
<style>
</style>
